export default {
  title: {
    id: 'product_page_upgrage_modal_title',
    defaultMessage: 'Upgrade for less',
  },
  description: {
    id: 'product_page_upgrage_modal_description',
    defaultMessage:
      'Right now a different seller is listing an even better device for less cash. You in? ',
  },
  upgradeAccept: {
    id: 'product_page_upgrage_modal_upgrade_accept',
    defaultMessage: 'Upgrade',
  },
  upgradeCancel: {
    id: 'product_page_upgrage_modal_upgrade_cancel',
    defaultMessage: 'Cancel',
  },
}
